// extracted by mini-css-extract-plugin
export default {"badgeSpace":"locationSummary_badgeSpace__YhL4f"};